import { render, staticRenderFns } from "./clientePeriodoTransportes.vue?vue&type=template&id=3a97bab2&"
import script from "./clientePeriodoTransportes.vue?vue&type=script&lang=js&"
export * from "./clientePeriodoTransportes.vue?vue&type=script&lang=js&"
import style0 from "./clientePeriodoTransportes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports